import React, { Component } from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import gql from 'graphql-tag'
import { flowRight as compose } from 'lodash'
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FormGroup, Col, FormControl, Row } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import Loader from '../../Common/Loader';

import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';

import validate from './validate';
import messages from '../../../locale/messages';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

import { withMutation } from '../../../hoc/withGraphql';
import bt from '../../../components/commonStyle.css';
import s from './ChangeAdminForm.css';


class ChangeAdminForm extends Component {

  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  static defaultProps = {
    loading: false
  };


  async submitForm(values, dispatch) {
    try {
      const isRestrict = await dispatch(demoRestriction({}));
      if (isRestrict) return;
      dispatch(setLoaderStart('changePassword'));
      const { mutate } = this.props;
      const { data } = await mutate({ variables: values });
      if (data && data.changeAdminUser) {
        if (data.changeAdminUser.status === 200) {
          showToaster({ messageId: 'passwordChange', toasterType: 'success' });
        } else {
          showToaster({ messageId: 'errorMessage', requestContent: data?.changeAdminUser?.errorMessage, toasterType: 'error' });
        }
      }
      dispatch(setLoaderComplete('changePassword'));
      dispatch(reset('ChangeAdminForm'));
    } catch (error) {
      showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
    }

  }

  render() {

    const { error, handleSubmit, submitting, dispatch, title, isSuperAdmin, loading } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div className={s.Section}>
        <form onSubmit={handleSubmit(this.submitForm)}>
          {error && <strong>{error}</strong>}
          <div className='oneColumnGrid'>
            {
              isSuperAdmin &&
              <Field
                name="email"
                type="text"
                component={InputFieldComponent}
                label={formatMessage(messages.emailaddress)}
                placeholder={formatMessage(messages.emailaddress)}
                note={formatMessage(messages.leaveEmail)}
                inputClass={bt.formControlInput}
              />
            }
            <Field
              name="password"
              type="password"
              component={InputFieldComponent}
              label={formatMessage(messages.password)}
              placeholder={formatMessage(messages.password)}
              inputClass={bt.formControlInput} />
            <Field
              name="confirmPassword"
              type="password"
              component={InputFieldComponent}
              label={formatMessage(messages.confirmPassword)}
              placeholder={formatMessage(messages.confirmPassword)}
              inputClass={bt.formControlInput} />
          </div>
          <div className='commonButtonContainer'>
            <Loader
              type={"button"}
              label={formatMessage(messages.submitButton)}
              show={loading}
              buttonType={'submit'}
              className={cx(bt.btnPrimary, 'loaderButtonFlex')}
              disabled={submitting || loading}
            />
          </div>
        </form>
      </div>
    );
  }

}

ChangeAdminForm = reduxForm({
  form: 'ChangeAdminForm',
  validate
})(ChangeAdminForm);

const mapState = (state) => ({
  isSuperAdmin: state.runtime.isSuperAdmin,
  loading: state.loader.changePassword
});

const mapDispatch = {};

export default injectIntl(compose(
  withStyles(bt, s),
  connect(mapState, mapDispatch),
  withMutation(gql`
    mutation changeAdminUser($email: String, $password: String!) {
      changeAdminUser (email: $email, password: $password) {
        status
        errorMessage
      }
    }
  `),
)(ChangeAdminForm));
